module.exports = __webpack_public_path__ + "img/ileti.30297d5e.png";